const CHECKOUT_CHARGES = {
  greece: 1.99,
  cyprus: 3,
};

export default CHECKOUT_CHARGES;
